$(document).ready(function () {
  $('li.ctm-model-navs').on('click', function(){
    $(this).siblings().removeClass('active');
    $(this).addClass('active');
    
    let get_data_hover = $(this).attr('data-hover');
    $('img.nav-image-main').hide();
    $('img.nav-image-main.'+get_data_hover).show();
});
// $('.custom-btns-sldie.custom-gallery-btns-nav .right').on('click', function(){
//    $('li.ctm-model-navs.active').next('li').trigger('click');
// });
//   $('.custom-btns-sldie.custom-gallery-btns-nav .left').on('click', function(){
//    $('li.ctm-model-navs.active').prev('li').trigger('click');
// });

  $('.custom-btns-sldie.custom-gallery-btns-nav .right').on('click', function() {
    var $nextItem = $('li.ctm-model-navs.active').next('li');
    if ($nextItem.length > 0) {
        $nextItem.trigger('click');
        $(this).removeAttr('disabled');
        $('.custom-btns-sldie.custom-gallery-btns-nav .left').removeAttr('disabled');
    } else {
        $(this).attr('disabled', 'disabled');
    }
});

$('.custom-btns-sldie.custom-gallery-btns-nav .left').on('click', function() {
    var $prevItem = $('li.ctm-model-navs.active').prev('li');
    if ($prevItem.length > 0) {
        $prevItem.trigger('click');
        $(this).removeAttr('disabled');
        $('.custom-btns-sldie.custom-gallery-btns-nav .right').removeAttr('disabled');
    } else {
        $(this).attr('disabled', 'disabled');
    }
});

  
  $('button.product__media-toggle.product__media-zoom-lightbox').on('click', function(){
    $('product-modal.product-media-modal.media-modal').css({
        'visibility': 'visible',
        'opacity': '1',
        'z-index': '101'
    });
});
  
$('product-modal.product-media-modal.media-modal .product-media-modal__toggle').on('click', function(){
    $('product-modal.product-media-modal.media-modal').css({
        'visibility': 'hidden',
        'opacity': '0',
        'z-index': '1'
    });
});
  
  /*******gallery-buttons-start*******/
   var ctn_length = $('.thumbnail-list__item').length;

  if (ctn_length > 1) {
    $('.left').show();
    $('.right').show();
  } else {
    $('.left').hide();
    $('.right').hide();
  }

  // Right button click
  $(".grid__item.product__media-wrapper button.right").click(function() {
    console.log(4564);

    var btnn = $('.thumbnail-list .thumbnail-list__item button.thumbnail[aria-current="true"]');
    var nextItem = btnn.closest('li.thumbnail-list__item').next().find('button.thumbnail');

    if (nextItem.length > 0) {
      nextItem.click();
      // Enable/disable buttons based on the position
      $('.left').prop('disabled', false);
      if (!nextItem.closest('li').next().length) {
        $(this).prop('disabled', true);
      } else {
        $(this).prop('disabled', false);
      }
    }
  });

  // Left button click
  $(".grid__item.product__media-wrapper button.left").click(function() {
    console.log(4564);

    var btnn = $('.thumbnail-list .thumbnail-list__item button.thumbnail[aria-current="true"]');
    var prevItem = btnn.closest('li.thumbnail-list__item').prev().find('button.thumbnail');

    if (prevItem.length > 0) {
      prevItem.click();
      // Enable/disable buttons based on the position
      $('.right').prop('disabled', false);
      if (!prevItem.closest('li').prev().length) {
        $(this).prop('disabled', true);
      } else {
        $(this).prop('disabled', false);
      }
    }
  });

  // Initial check to disable buttons if no prev or next item exists
  var initialBtn = $('.thumbnail-list .thumbnail-list__item button.thumbnail[aria-current="true"]');
  if (!initialBtn.closest('li').prev().length) {
    $('.left').prop('disabled', true);
  }
  if (!initialBtn.closest('li').next().length) {
    $('.right').prop('disabled', true);
  }

  /*******gallery-buttons-end*******/
  
  /*******edite-product-start*******/
  var cmt_currentUrl = window.location.href;
    if (cmt_currentUrl.includes('cart-index')) {
        $('.curtom-buy-upgrade').show();
        $('.buy-btn-qunt-wrp').hide();
    } else {
         $('.curtom-buy-upgrade').hide();
        $('.buy-btn-qunt-wrp').show();
    }

  $('.curtom-buy-upgrade .upgrade-btn').on('click',function(){
      var url = window.location.href;
      var match = url.match(/cart-index=(\d+)/);
      var cartIndex = match ? match[1] : null;
      
          let qunt_pp = $('.button-main-wrp .quantity__input').val();
      console.log(qunt_pp + ' gfg ' + cartIndex);
      
      $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: $.param({
              line: cartIndex,
              quantity: qunt_pp
          }),
          dataType: 'json',
          success: function(cart) {
              console.log('Quantity updated successfully!');
             window.location.href = "/cart"
          },
          error: function() {
              alert('There was an error updating the quantity.');
          }
      });
      });
  /*******edite-product-end*******/
  
  
  
  /*******accordion--start*******/
  $(".accordion-title").on("click", function () {
    $(this).toggleClass("active");
    $(this).siblings(".accordion-content").toggle();
  });
  /*******accordion--end*******/

  /*******product collection view--start*******/
  $(".product-list-view span.grid-view").click(function () {
   $(".product-list-view span.list-view").removeClass('active')
    $(this).addClass('active');
    $(".collection ul#product-grid").removeClass("list-view");
  });
  $(".product-list-view span.list-view").click(function () {
    $(".product-list-view span.grid-view").removeClass('active')
    $(this).addClass('active');
    $(".collection ul#product-grid").addClass("list-view");
  });
  /*******product collection view--end*******/
  

  
});
